export default "__VITE_ASSET__BY4DsUXe__"